import { get, set } from "lodash";
import { DATA_SOURCE_FACADE, DATA_SOURCE_FACADE_MAP } from "./deal.constants";
import numberFormatter from "../../utils/numberFormatter";

export const getDataSourceFromURL = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("source");
};

export const getDataSourceFromADeal = deal =>
  Object.keys(DATA_SOURCE_FACADE)
    .map((k) => DATA_SOURCE_FACADE[k])
    .find((s) => s === DATA_SOURCE_FACADE_MAP[deal.dataSource]) || null;

const getLoanTermYears = loan => {
  const { loanTermMonths } = loan;
  if (loanTermMonths) {
    return `${(loanTermMonths / 12).toFixed(2)} Years`;
  }

  return "N/A";
};

const getInterestRateType = loan => get(loan, "rateTypeRef.name") || "N/A";

const getLoanAmount = loan => numberFormatter.maskCurrency(loan.amount) || "N/A";

export const formatForCompare = loan => ({
  id: loan.id,
  status: loan.loanStatusId,
  title: `${loan["lenderCompany.name"] || get(loan, "loanCompanyBridge[0].company.name") || "N/A"} | ${getLoanTermYears(
    loan
  )} | ${getInterestRateType(loan)} | ${getLoanAmount(loan)}`
});

const stringsToNumbers = (values, paths) => {
  const toUpdate = { ...values };
  paths.forEach(path => {
    let value = get(toUpdate, path, null);
    if (!value) {
      return;
    }

    if (typeof value === "string") {
      value = Number(value.replace(/[^0-9.-]+/g, ""));
    }
    set(toUpdate, path, value);
  });

  return toUpdate;
};

const stringsToIsoDate = (values, paths) => {
  const toUpdate = { ...values };
  paths.forEach(path => {
    let value = get(toUpdate, path, null);
    if (!value) {
      return;
    }
    if (typeof value === "string") {
      const date = new Date(value);
      value = date.toISOString();
    }
    set(toUpdate, path, value);
  });

  return toUpdate;
};

export const sanitizeDeal = values => {
  const maskPaths = [
    "loan.amount",
    "loan.interestRate",
    "loan.loanSpread",
    "broker.phone",
    "lender.phone",
    "lenderCounsel.phone"
  ];
  const datePaths = [
    "loan.closingDate",
    "loan.maturityDate",
    "mezzLoan.closingDate",
    "mezzLoan.maturityDate"
  ];

  return {
    ...stringsToNumbers(values, maskPaths),
    ...stringsToIsoDate(values, datePaths),
    supplementalLoans: values.supplementalLoans && values.supplementalLoans.map(supplementalLoan => stringsToNumbers(supplementalLoan, [
      "amount",
      "interestRate",
      "loanSpread",
      "broker.phone",
      "lender.phone",
      "lenderCounsel.phone"
    ]))
  };
};

export default sanitizeDeal;
